import { Column } from '@devexpress/dx-react-grid';
import * as H from 'history';

// TODO we need translations 

export const getColumns = (history: H.History) : Column[] => [
    {'title': 'Number of Player', 'name': 'numberOfPlayer'},
    {'title': "Number of player redeemed game prize", 'name': 'numberOfPlayerRedeemedGamePrize'}
]